module.exports = __webpack_public_path__ + "img/Image.1745aa4d.png";